import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button, Group, Stack } from '@mantine/core';
import BulkPricingFacetPanel from './BulkPricingFacetPanel/BulkPricingFacetPanel';
import { OrgJobsPanel } from './OrgJobs/OrgJobsPanel';
import { INode } from './Types/BulkPricingTypes';
import SurveyJobPanel from './SurveyJob/SurveyJobPanel';
import { getFieldData } from './utils';
import './BulkPricing.scss';

interface Props {
  usePropagateMatches: boolean;
  useJobCodeKey: boolean;
}

export default function BulkPricing({ usePropagateMatches, useJobCodeKey }: Props) {
  const [facetCollapse, setFacetCollapse] = useState(true);
  const [checkedSurveyDataCuts, setcheckedSurveyDataCuts] = useState<INode[]>([]);
  const [orgJobs, setOrgJobs] = useState<INode[]>([]);
  const [orgJobsLoading, setOrgJobsLoading] = useState(true);

  const disablePropagate = useMemo(() => {
    return orgJobsLoading || orgJobs.some(job => {
      const matchCount: number = getFieldData('match_count_default', job.data, job.terms);
      return !matchCount;
    })
  }, [orgJobs, orgJobsLoading]);

  return (
    <Stack className='bulk-pricing'>
      <Group
        align='center'
        justify='flex-end'
        mt='sm'
        mr='xl'
      >
       {usePropagateMatches && useJobCodeKey && (
          <Button
            className='bulk-pricing-propagate-matches'
            component={Link}
            size='xl'
            to='/market-analysis/propagate-matches'
            variant='outline'
            fz='sm'
            td='none'
            data-disabled={disablePropagate}
            onClick={disablePropagate ? ((event) => event.preventDefault()) : undefined}
          >
            Propagate Matches
          </Button>
        )}
        <Button
          component={Link}
          size='xl'
          to={{
            pathname: '/market-analysis/market-pricing',
            state: {
              notFirstLoad: true,
              searchQuery: (location as any)?.state?.searchQuery,
              offset: (location as any)?.state?.offset,
              bulkPricing: true
            }
          }}
          variant='filled'
          fz='sm'
          td='none'
        >
          Close
        </Button>
      </Group>
      <Group style={{ flexWrap: 'nowrap', gap: 0 }} className='facet-panel-group'>
        <BulkPricingFacetPanel
          collapseCallback={setFacetCollapse}
          collapseTooltip={facetCollapse ? 'Close survey job filters' : 'Open survey job filters'}
        />
        <SurveyJobPanel checkedDataCuts={checkedSurveyDataCuts} setCheckedDataCuts={setcheckedSurveyDataCuts}/>
        <OrgJobsPanel 
          checkedDataCuts={checkedSurveyDataCuts} 
          setCheckedDataCuts={setcheckedSurveyDataCuts} 
          orgJobs={orgJobs}
          setOrgJobs={setOrgJobs}
          orgJobsLoading={orgJobsLoading}
          setOrgJobsLoading={setOrgJobsLoading}
        />
      </Group>
    </Stack>
  );
}

